import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
export const pickItemIdInputSchema = z.object({
    pickItemId: requiredUuidString('Pick item is required.', 'Invalid pick item selection.'),
});
//# sourceMappingURL=pick-item-id-input.js.map